import React, { Component, useEffect, useState, CSSProperties } from 'react'
import functions from '../utils/functions'
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ajax from '../utils/ajax';


const Sliders = (props) => {


    const [mostClickList, setMostClickList] = useState(false);
    const [userId, setUserId] = useState(functions.sessionGuard())
    const nav = useHistory();

    const settings = {
        dots: true,
        speed: 1000,
        autoplaySpeed: 5000,
        autoplay: true,
        infinite: true,
        slidesToShow: 4,
        pauseOnHover: true,
        slidesToScroll: 1,
        initialSlide: 0,

        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },


            {
                breakpoint: 600,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 576,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 540,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 480,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    centerMode: false,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div>

            <div class="team4-slider-area" >

                {/* <h1>gdafafadf</h1> */}

                <Slider {...settings}>
                    <div class="team4-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/team/team-img44.png" alt="" class="team-img10" />
                            <img src="assets/img/elements/elements13.png" alt="" class="elements13 keyframe5" />
                        </div>
                        <div class="name-area">
                            <a href="#">Dr. Julius Okello</a>
                            <div class="space12"></div>
                            <p>Head of Rehabilitation Services</p>
                        </div>
                    </div>

                    <div class="team4-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/team/team-img16.png" alt="" class="team-img10" />
                            <img src="assets/img/elements/elements13.png" alt="" class="elements13 keyframe5" />
                        </div>
                        <div class="name-area">
                            <a href="#">Dr. Nicholas Byaruhanga</a>
                            <div class="space12"></div>
                            <p>Head of Nutrition/ Dietician</p>
                        </div>
                    </div>
                    <div class="team4-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/team/team-img17.png" alt="" class="team-img10" />
                            <img src="assets/img/elements/elements13.png" alt="" class="elements13 keyframe5" />
                        </div>
                        <div class="name-area">
                            <a href="#">Dr. Ocan Innocent</a>
                            <div class="space12"></div>
                            <p>Head physiotherapy Department</p>
                        </div>
                    </div>
                    <div class="team4-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/team/team-img18.png" alt="" class="team-img10" />
                            <img src="assets/img/elements/elements13.png" alt="" class="elements13 keyframe5" />
                        </div>
                        <div class="name-area">
                            <a href="#">Ms. Natukunda Patience</a>
                            <div class="space12"></div>
                            <p>Head of Nursing/ Home based services</p>
                        </div>
                    </div>

                    <div class="team4-boxarea">
                        <div class="img1">
                            <img src="assets/img/all-images/team/team-img32.png" alt="" class="team-img10" />
                            <img src="assets/img/elements/elements13.png" alt="" class="elements13 keyframe5" />
                        </div>
                        <div class="name-area">
                            <a href="#">Dr. Ebyarimpa Medard</a>
                            <div class="space12"></div>
                            <p>Consultant surgeon.</p>
                        </div>
                    </div>
                </Slider>
            </div>

        </div>
    )
}
export default Sliders